import uniqBy from 'lodash/uniqBy';

import { MatchColumnsProps, MatchedOptions } from '../types';
import { normalizeMultiValue } from './normalizeMultiValue';

export const uniqueEntries = <T extends string>(
  data: MatchColumnsProps<T>['data'],
  index: number
): Partial<MatchedOptions<T>>[] =>
  uniqBy(
    data.map((row) => ({ entry: row[index] })),
    'entry'
  ).filter(({ entry }) => !!entry);

export const uniqueMultivaluedEntries = <T extends string>(
  data: MatchColumnsProps<T>['data'],
  index: number,
  valueSeparator: string | undefined
): Partial<MatchedOptions<T>>[] =>
  uniqBy(
    data.map((row) => ({ entry: row[index] })),
    'entry'
  )
    .filter(({ entry }) => !!entry && entry !== ' ')
    .reduce(
      (acc, curr) => {
        const values = normalizeMultiValue(curr.entry, valueSeparator) ?? [];
        const entries = values
          .filter((value) => !acc.find((el) => el.entry === value))
          .map((value) => ({ entry: value }));
        return [...acc, ...entries];
      },
      [] as Partial<MatchedOptions<T>>[]
    );
